import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TaxActionButtons from './actionButtons/TaxActionButtons';
import translateColumns, { translateSort } from '../dataTable/dataTranslate';
import DataTable from '../dataTable';

const TaxAutoPopTable = props => {
  const { displayData, onListingSelected, isModal = false } = props;

  const actionsFormatter = (cell, row) => (
    <TaxActionButtons
      listingClicked={onListingSelected}
      index={Number(row.UniqueID)}
    />
  );
  const hdrSortClasses = (_column, sortOrder) => `sorting_${sortOrder}`;

  const columns = [
    {
      dataField: 'actions',
      text: 'Actions',
      formatter: actionsFormatter,
      headerStyle: { width: '55px' },
    },
    {
      dataField: 'ParcelNumber',
      text: 'LincNumber',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'UnitNumber',
      text: 'Unit #',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'StreetNumber',
      text: 'Street #',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'StreetName',
      text: 'Street Name',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'StreetSuffix',
      text: 'Street Suffix',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
  ];

  const defaultSorted = [
    {
      dataField: 'UniqueID',
      order: 'desc',
    },
  ];

  const newCols = useMemo(() => translateColumns(columns), [columns]);

  return (
    <DataTable
      defaultSorted={translateSort(defaultSorted)}
      columns={newCols}
      sizePerPage={isModal ? 5 : 10}
      data={displayData}
      wrapperClasses="table-responsive"
      id="officesTable"
      noDataIndication="No Data Returned."
      classes="dataTable"
      striped
      hover
    />
  );
};

TaxAutoPopTable.propTypes = {
  displayData: PropTypes.arrayOf(PropTypes.shape()),
  onListingSelected: PropTypes.func.isRequired,
  isModal: PropTypes.bool,
};

export default TaxAutoPopTable;
